import React from 'react';
import { syncCollections, syncCollection, syncCollectionMetafields, saveCollections, createCollectionCustomContents, deleteCollectionCustomContent, exportCollections, importCollections, clearExportUrls, resetErrors } from '../../modules/collections'
import withRouter from 'with-router'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import ItemsList from '../../components/ItemsList'
import ItemsListSkeleton from '../../components/ItemsListSkeleton'
import LoadingIndicator from '../../components/LoadingIndicator';
import EmptyView from '../../components/EmptyView';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import OptionsMenu from '../../components/OptionsMenu';
import NewFlexItemList from '../../components/NewFlexItemList';
import cloneDeep from 'lodash/cloneDeep';
import Link from '@mui/material/Link';
import { Trans, withTranslation, useTranslation } from 'react-i18next';
import ExportImportDialogs from '../../components/ExportImportDialogs';
import { _clearUnchangedFields } from '../../helper';
import API from '../../api/api';


class Collections extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      data: [],
      addingNewCustomContent: false,
      addingNewCustomContentCollectionId: null,
      customContentPlainTextData: [],
      showDownloadDialog: true,
      showImportCompleteDialog: false,
      errorLockCollapse: false,
      forceOpenExportDialog: false,
      forceOpenImportDialog: false,
    }
  }

  componentDidMount() {
    this.props.syncCollections(this.props.editLanguage)
    if(this.props.collections.export_po_download_url || this.props.collections.export_csv_download_url) {
      this.setState({showDownloadDialog: false})
    }
  }

  componentWillUnmount() {
    API.clearAllFetches();
  }

  getErrorsFor(key, item) {
    if (typeof item.errors === 'undefined') return false;
    let error = item.errors.find(x => x.object_key === key);
    return error;
  }

  componentWillReceiveProps(newProps) {
    const { t } = this.props;
    const currentLanguage = this.props.editLanguage;
    const newLanguage = newProps.editLanguage;
    if(currentLanguage != newLanguage) {
      this.props.syncCollections(newLanguage)
      return
    }

    if(this.props.collections.import_collections_pending === true && newProps.collections.import_collections_pending === false && !newProps.collections.error && !newProps.collections.import_cancelled) {
      this.setState({showImportCompleteDialog: true}, () => {
        this.setState({showImportCompleteDialog: false});
      })
    }

    if((this.props.collections.sync_collection_pending === true && newProps.collections.sync_collection_pending === false) || (this.props.collections.save_collections_pending === true && newProps.collections.save_collections_pending === false) || (this.props.collections.sync_collections_pending === true && newProps.collections.sync_collections_pending === false)) {
      const newData = [];

      newProps.collections.collections.forEach(item => {
        let customFields = []
        if(item.custom_contents) {
          item.custom_contents.forEach(custom_content => {
            customFields.push({
              id: custom_content.id,
              type: 'text',
              deletable: true,
              multiline: true,
              rows: 7,
              source: custom_content.source.text,
              target: custom_content.target.text
            })
          })
        }

        let currentMetafields = null;
        if(!(this.props.collections.sync_collections_pending === true && newProps.collections.sync_collections_pending === false)) {
          const currentCollection = this.state.data.find(x => x.id == item.id);
          if(currentCollection) {
            currentMetafields = currentCollection.fields.find(x => x.id === 'metafields');
          }
        }

        let seoFields = []

        if(typeof item.target.page_title !== 'undefined') {
          seoFields.push({
            id: 'page_title',
            type: 'text',
            label: 'SEO Title',
            source: item.source.page_title || '',
            target: item.target.page_title || '',
            customized: item.customSeo.meta_title,
            maxLength: 255,
          })
        }

        if(typeof item.target.page_description !== 'undefined') {
          seoFields.push({
            multiline: true,
            rows: 6,
            id: 'page_description',
            type: 'text',
            label: 'SEO Description',
            source: item.source.page_description || '',
            target: item.target.page_description || '',
            customized: item.customSeo.meta_description,
            maxLength: 500,
          })
        }

        let imageFields = [];
        if(item.source.image) {
          const hasAlt = !!(item.source.collection_image && item.source.collection_image.alt);
          imageFields.push({
            id: 'image',
            type: 'image',
            hasAlt: hasAlt,
            source: item.source.image ? item.source.image.src : '',
            target: item.target.image ? item.target.image.src : ''
          });
          // the collection image's alt rides along as a paired text field, like product image alts
          if(hasAlt) {
            imageFields.push({
              id: 'image-alt',
              imageId: 'image',
              type: 'text',
              multiline: true,
              autoGrow: true,
              maxLength: 512,
              label: this.props.t('imageField.altLabel'),
              source: item.source.collection_image.alt,
              target: (item.target.collection_image && item.target.collection_image.alt) ? item.target.collection_image.alt : ''
            });
          }
        }

        newData.push({
          type: 'collection',
          id: item.id,
          shopify_id: item.shopifyId,
          progress: item.progress,
          synchronized: item.synchronized,
          metafields_synchronized: item.metafields_synchronized,
          title: item.source.title,
          info: '',
          fields: [{
            id: 'title',
            type: 'text',
            label: 'Title',
            source: item.source.title,
            target: item.target.title || ''
          },
          {
            multiline: true,
            rows: 10,
            id: 'body_html',
            type: 'richtext',
            label: 'Description',
            source: item.source.body_html || '',
            target: item.target.body_html || '',
          },
          {
            id: 'handle',
            type: 'text',
            label: 'Handle',
            source: item.source.handle,
            target: item.target.handle || '',
            errors: this.getErrorsFor('handle', item) || false
          },
          {
            id: 'seofields',
            type: 'subfields',
            fields: seoFields
          },
          {
            id: 'images',
            type: 'subfields',
            fields: imageFields
          },
          {
            id: 'metafields',
            type: 'subfields',
            fields: currentMetafields ? cloneDeep(currentMetafields.fields) : []
          },
          {
            id: 'customfields',
            onAddItem: this.openNewCustomContentDialog,
            onDeleteItem: this.onDeleteCustomContent(item.id),
            emptyMessage: <EmptyView 
              title={t('customContents.noCustomContentInSection')}
              description={t('customContents.info1')}
              bottom={<Button variant="outlined" size="small" onClick={e => {this.openNewCustomContentDialog(item.id)}}>{t('customContents.addNewCustomContent')}</Button>}
              dense={true} 
            />,
            type: 'subfields',
            fields: customFields
          }]
        })
      })
      
      this.setState({data:newData});
    }

    if(this.props.collections.sync_collection_metafields_pending === true && newProps.collections.sync_collection_metafields_pending === false) {
      let newData = cloneDeep(this.state.data);
      newProps.collections.collections.forEach(collection => {
        if(collection.metafields) {
            let collectionToUpdate = newData.find(x => x.id == collection.id)

            let newMetafields = []
            collection.metafields.forEach(metafield => {
              const currentField = collectionToUpdate.fields.find(x => x.id === 'metafields').fields.find(x => x.id == metafield.id);
              if(!currentField) {
                newMetafields.push({
                  id: metafield.id,
                  type: 'text',
                  multiline: true,
                  rows: 7,
                  source: metafield.source,
                  target: metafield.target || '',
                  label: metafield.namespace + ' -> ' + metafield.key
                })
              } else {
                if(collection.metafields.find(x => x.id === currentField.id)) {
                  newMetafields.push({...currentField});
                }
              }
            })

            collectionToUpdate.metafields_synchronized = collection.metafields_synchronized
            collectionToUpdate.fields.find(x => x.id === 'metafields').fields = newMetafields
        }
      })

      this.setState({data:newData});
    }

    if((this.props.collections.create_collection_custom_contents_pending === true && newProps.collections.create_collection_custom_contents_pending === false) || (this.props.collections.delete_collection_custom_content_pending === true && newProps.collections.delete_collection_custom_content_pending === false)) {
      let newData = cloneDeep(this.state.data);
      newProps.collections.collections.forEach(collection => {
        if(collection.custom_contents) {
            let collectionToUpdate = newData.find(x => x.id == collection.id)

            let newCustomContents = []
            collection.custom_contents.forEach(custom_content => {
              const currentField = collectionToUpdate.fields.find(x => x.id === 'customfields').fields.find(x => x.id == custom_content.id);
              if(!currentField) {
                newCustomContents.push({
                  id: custom_content.id,
                  type: 'text',
                  deletable: true,
                  multiline: true,
                  rows: 7,
                  source: custom_content.source.text,
                  target: custom_content.target.text
                })
              } else {
                if(collection.custom_contents.find(x => x.id === currentField.id)) {
                  newCustomContents.push({...currentField});
                }
              }
            })

            collectionToUpdate.fields.find(x => x.id === 'customfields').fields = newCustomContents
        }
      })

      this.setState({data:newData});
    }
  }

  onExpand(id) {
    if(this.state.data.find(x => x.id == id).synchronized !== true) {
      this.props.syncCollection(id, this.props.editLanguage);
    }
  }

  onCollapsed(id) {
  }

  onExpandCollapsableFields = (type, id) => {
    if(type === 'metafields' && this.state.data.find(x => x.id == id).metafields_synchronized != true) {
      this.props.syncCollectionMetafields(id, this.props.editLanguage)
    }
  }


  onSave = items => {
    const usedItems = [];
    items.forEach(item => {
      usedItems.push({
        id: item.id,
        title: item.fields.find(x => x.id === 'title').target,
        body_html: item.fields.find(x => x.id === 'body_html').target,
        handle: item.fields.find(x => x.id === 'handle').source == item.fields.find(x => x.id === 'handle').target ? '' : item.fields.find(x => x.id === 'handle').target,
        page_title: item.fields.find(x => x.id === 'seofields').fields.find(x => x.id === 'page_title').target,
        page_description: item.fields.find(x => x.id === 'seofields').fields.find(x => x.id === 'page_description').target,
        metafields: item.fields.filter(x => (x.type === 'subfields' && x.id === 'metafields'))[0].fields.map(z => ({ id: z.id, target: z.target })),
        custom_contents: item.fields.filter(x => (x.type === 'subfields' && x.id === 'customfields'))[0].fields.map(z => ({ id: z.id, target: z.target })),
        images: item.fields.filter(x => (x.type === 'subfields' && x.id === 'images'))[0].fields.filter(z => z.type === 'image').map(z => ({ id: z.id, target: z.target })),
        collection_image: (() => { const alt = item.fields.filter(x => (x.type === 'subfields' && x.id === 'images'))[0].fields.find(z => z.id === 'image-alt'); return alt ? { alt: alt.target || '' } : undefined; })(),
      });
    })

    this.props.saveCollections(this.props.editLanguage, usedItems)
  }

  onResaveAll = (itemId) => {
    const item = this.state.data.find(x => x.id == itemId);
    if(item) {
      const usedItems = [{
        id: item.id,
        title: item.fields.find(x => x.id === 'title').target,
        body_html: item.fields.find(x => x.id === 'body_html').target,
        page_title: item.fields.find(x => x.id === 'seofields').fields.find(x => x.id === 'page_title').target,
        page_description: item.fields.find(x => x.id === 'seofields').fields.find(x => x.id === 'page_description').target,
        metafields: item.fields.filter(x => (x.type === 'subfields' && x.id === 'metafields'))[0].fields.map(z => ({ id: z.id, target: z.target })),
        custom_contents: item.fields.filter(x => (x.type === 'subfields' && x.id === 'customfields'))[0].fields.map(z => ({ id: z.id, target: z.target })),
        images: item.fields.filter(x => (x.type === 'subfields' && x.id === 'images'))[0].fields.filter(z => z.type === 'image').map(z => ({ id: z.id, target: z.target })),
        collection_image: (() => { const alt = item.fields.filter(x => (x.type === 'subfields' && x.id === 'images'))[0].fields.find(z => z.id === 'image-alt'); return alt ? { alt: alt.target || '' } : undefined; })(),
      }]

      this.props.saveCollections(this.props.editLanguage, usedItems, 1)
    }
  }

  openNewCustomContentDialog = (itemId) => {
    const customContentPlainTextData = [];
    const collection = this.state.data.find(x => x.id == itemId);

    collection.fields.find(x => x.id == 'customfields').fields.forEach((custom_content) => {
      customContentPlainTextData.push(custom_content.source);
    })

    this.setState({addingNewCustomContent: true, addingNewCustomContentCollectionId: itemId, customContentPlainTextData: customContentPlainTextData})
  }

  closeNewCustomContentDialog = ()  => {
    this.setState({addingNewCustomContent: false, addingNewCustomContentCollectionId: null, customContentPlainTextData: []})
  }

  onSaveNewCustomContentDialog = (collectionId, items) => {
    const usedItems = [];
    items.forEach(item => {
      if(item.text != '') {
        usedItems.push({
          text: item.text
        })
      }
    })
    
    this.setState({addingNewCustomContent: false, addingNewCustomContentCollectionId: null});
    this.props.createCollectionCustomContents(collectionId, this.props.editLanguage, usedItems);
  }

  onDeleteCustomContent = collectionId => {
    return itemId => {
      this.props.deleteCollectionCustomContent(collectionId, itemId);
    }
  }
  
  onImport = (e) => {
    this.setState({forceOpenImportDialog: true}, () => {
      this.setState({forceOpenImportDialog: false});
    });   
    this.setState({ optionsMenuAnchorEl: null });
  }

  onExport = (e) => {
    this.setState({forceOpenExportDialog: true}, () => {
      this.setState({forceOpenExportDialog: false});
    });
  }

  onCloseDownloadDialog = () => {
    this.setState({showDownloadDialog: false})
  }
  
  onCloseImportCompleteDialog = () => {
    window.location.reload();
  }

  render() {
    const { t, classes } = this.props

    if(this.props.collections.sync_collections_pending === true || (this.props.collections.error && this.props.collections.error.level === 0)) {
      return <React.Fragment>
        <Typography variant="h4" gutterBottom component="h2">
          {t('pages.collections.title')}
        </Typography>
        <Divider className="divider-white" />
        <ItemsListSkeleton rows="10"/>
        <LoadingIndicator
          pending={this.props.collections.sync_collections_pending || this.props.collections.sync_collection_pending || this.props.collections.save_collections_pending || this.props.collections.sync_collection_metafields_pending || this.props.collections.export_collections_pending || this.props.collections.import_collections_pending}
          progress={this.props.collections.progress}
          error={this.props.collections.error}
        />
      </React.Fragment>  
    }

    return <React.Fragment>
      <Typography variant="h4" gutterBottom component="h2">
        {t('pages.collections.title')}

         <OptionsMenu
           dataTour="page-options-menu"
          onImport={this.onImport}
          onExport={this.onExport}
          shopPlan={this.props.shopPlan}
        />
      </Typography>

      {this.state.addingNewCustomContent ? (
        <NewFlexItemList
          scope={this.state.addingNewCustomContentCollectionId}
          data={this.state.customContentPlainTextData}
          onSave={this.onSaveNewCustomContentDialog}
          onCancel={this.closeNewCustomContentDialog}
          isPending={false}
        />
      ) : (
        null
      )}

      <Divider className="divider-white" />
      <ItemsList 
        type="collections"
        pagination={true}
        onExpand={(id) => {this.onExpand(id)}}
        onCollapsed={this.onCollapsed}
        isPending={
          this.props.collections.sync_collections_pending ||
          this.props.collections.sync_collection_pending ||
          this.props.collections.sync_collection_metafields_pending ||
          this.props.collections.create_collection_custom_contents_pending ||
          this.props.collections.delete_collection_custom_content_pending ||
          this.props.collections.save_collections_pending ||
          this.props.collections.export_collections_pending ||
          this.props.collections.import_collections_pending
        }
        isSubfieldsPending={
          this.props.collections.create_collection_custom_contents_pending ||
          this.props.collections.delete_collection_custom_content_pending ||
          this.props.collections.sync_collection_metafields_pending
        }
        isSubfieldsRemoving={
          this.props.collections.delete_collection_custom_content_pending
        }
        isSaving={
          this.props.collections.save_collections_pending
        }
        onSave={this.onSave}
        onResaveAll={this.onResaveAll}
        data={this.state.data}
        onExpandCollapsableFields={this.onExpandCollapsableFields}
        allowAutoTranslation={true}
        error={this.props.collections.error}
        errorLockCollapse={this.state.errorLockCollapse}
        emptyMessage={
          <EmptyView 
            title={t('pages.collections.noContent')}
            bottom={<Button href={`https://${this.props.shopUrl}/admin/collections`} target="_blank" variant="contained" color="primary">{t('system.createOneHere')}</Button>}
          />
        }
      />
      <LoadingIndicator
        pending={this.props.collections.sync_collections_pending || this.props.collections.sync_collection_pending || this.props.collections.sync_collection_metafields_pending || this.props.collections.save_collections_pending || this.props.collections.export_collections_pending || this.props.collections.import_collections_pending || this.props.collections.create_collection_custom_contents_pending || this.props.collections.delete_collection_custom_content_pending}
        loadingType={this.props.collections.save_collections_pending ? 'saving' : 'loading'}
        progress={this.props.collections.progress}
        error={this.props.collections.error}
        onErrorCancel={this.props.resetErrors}
        onErrorRetry={() => {
          this.setState({ errorLockCollapse: true }, () => {
            this.setState({ errorLockCollapse: false });
          });
        }}
      />

      <ExportImportDialogs
        //showDownloadDialog={this.state.showDownloadDialog}
        showImportCompleteDialog={this.state.showImportCompleteDialog}
        imported_entries={this.props.collections.imported_entries}
        export_po_download_url={this.props.collections.export_po_download_url}
        export_csv_download_url={this.props.collections.export_csv_download_url}
        forceOpenExportDialog={this.state.forceOpenExportDialog}
        forceOpenImportDialog={this.state.forceOpenImportDialog}
        exportFunc={(options) => { this.props.exportCollections(this.props.editLanguage, options) }}
        importFunc={(formData, fileType, options) => { this.props.importCollections(formData, fileType, this.props.editLanguage, options) }}
        syncFunc={() => { this.props.syncCollections(this.props.editLanguage)}}
        clearFunc={this.props.clearExportUrls}
        pending={this.props.collections.export_collections_pending}
        scope={'collections'}
        additionalFields={['custom_contents','with_BOM']}
      />
    </React.Fragment> 
  }
}

const mapStateToProps = ({ collections, shop }) => ({
  collections: collections,
  editLanguage: shop.shop.edit_language,
  shopPlan: shop.shop.charge.name,
  shopUrl: shop.shop.url,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      syncCollections,
      syncCollection,
      syncCollectionMetafields,
      saveCollections,
      createCollectionCustomContents,
      deleteCollectionCustomContent,
      exportCollections,
      importCollections,
      resetErrors,
      clearExportUrls
    },
    dispatch
  )

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Collections)))